import { Link } from "react-router-dom";
import { Clock, Users, ArrowRight } from "lucide-react";
import { useLanguage, pick } from "@/i18n";
import FavoriteButton from "@/components/FavoriteButton";

export default function ExperienceCard({ exp }) {
  const { lang, t } = useLanguage();
  return (
    <Link
      to={`/experiences/${exp.slug}`}
      data-testid={`experience-card-${exp.slug}`}
      className="group block img-zoom"
    >
      <div className="relative overflow-hidden aspect-[4/5] bg-stonelt">
        <img
          src={exp.image}
          alt={pick(exp.title, lang)}
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <div className="absolute top-4 left-4 flex flex-wrap gap-2">
          {exp.badges.map((b) => (
            <span
              key={b}
              data-testid={`badge-${exp.slug}-${b.toLowerCase().replace(/_/g, "-")}`}
              className="bg-ivory/90 backdrop-blur text-ink text-[10px] font-medium uppercase tracking-[0.15em] px-3 py-1.5"
            >
              {t(`badge_${b.replace(/ /g, "_")}`)}
            </span>
          ))}
        </div>
        <div className="absolute top-4 right-4">
          <FavoriteButton slug={exp.slug} />
        </div>
      </div>
      <div className="pt-5">
        <div className="text-[11px] uppercase tracking-[0.2em] text-ink/40 mb-2">
          {pick(exp.destination_name, lang) || exp.destination}
        </div>
        <h3 className="font-serif text-2xl leading-tight text-ink group-hover:text-medblue transition-colors duration-300">
          {pick(exp.title, lang)}
        </h3>
        <p className="mt-2 text-sm text-ink/55 leading-relaxed line-clamp-2">{pick(exp.short, lang)}</p>
        <div className="flex items-center gap-4 mt-3 text-xs text-ink/50">
          <span className="flex items-center gap-1.5">
            <Clock size={13} strokeWidth={1.5} /> {pick(exp.duration, lang)}
          </span>
          <span className="flex items-center gap-1.5">
            <Users size={13} strokeWidth={1.5} /> {pick(exp.group_size, lang)}
          </span>
        </div>
        <div className="flex items-center justify-end mt-4 pt-4 border-t border-stone2/50">
          <span className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.2em] text-medblue">
            {t("discover")} <ArrowRight size={13} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
          </span>
        </div>
      </div>
    </Link>
  );
}
